import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteData from './autocomplete/AutoCompleteData';
import AutoCompleteField from './autocomplete/AutoCompleteField';
import { Field } from 'redux-form';

const AutoCompleteFilter = (props) => {
    const {
        formatSuggestion,
        input,
        label,
        minLength,
        optionValue,
        reference,
        searchBy,
        searchParams,
    } = props;

    return (
        <AutoCompleteData
            input={ input }
            minLength={ minLength }
            reference={ reference }
            searchBy={ searchBy }
            searchParams={ searchParams }
        >
            <Field
                component={ AutoCompleteField }
                formatSuggestion={ formatSuggestion }
                fullWidth={ true }
                input={ input }
                label={ label ? label : null }
                name={ input.name }
                optionText={ searchBy }
                optionValue={ optionValue }
            />
        </AutoCompleteData>
    );
};

AutoCompleteFilter.defaultProps = {
    minLength: 3,
    optionValue: 'id',
    searchParams: {},
};

AutoCompleteFilter.propTypes = {
    formatSuggestion: PropTypes.func,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        value: PropTypes.value,
    }),
    label: PropTypes.string,
    minLength: PropTypes.number,
    optionValue: PropTypes.string,
    reference: PropTypes.string.isRequired,
    searchBy: PropTypes.string.isRequired,
    searchParams: PropTypes.object,
};

export default AutoCompleteFilter;



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/AutoCompleteFilter.js